/*
  Our Story (round 28): the flock after the doors. sections/vr-story.liquid calls VRStoryFlock.play(ms until the doors
  begin to open); without it (reduced motion, no room, a page opened part-way down) the mark is simply there.

  1. As the doors part, small birds pour out of the light in the gap, dark against the glare at first and turning
     gold as the light settles, flying out towards the visitor.
  2. They gather into one flock and sweep over the hall as a murmuration: a single body that drifts, stretches and
     turns, each bird a moment behind the one beside it, so waves run through it.
  3. The flock turns for the middle of the hall and streams into the house mark: each bird flies to its own place in
     one of the two doves, folds its wings and becomes a grain of gold, until the doves stand drawn in gold dust.
  4. The dust becomes the mark itself (the mark of assets/vr-brand-birds.js fades in beneath it), one band of light
     crosses the doves, and the title comes in beneath them. The gold leaf of the page begins then.
  A scroll, a tap or a key ends the show at once: the mark is in its place and the title is there.
*/
(function () {
  'use strict';
  if (window.VRStoryFlock) return;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  /* the gold of the mark (assets/vr-brand-birds.js), dark to light */
  var GOLD = [[0, [138, 100, 17]], [0.4, [197, 155, 44]], [0.78, [233, 199, 97]], [1, [207, 169, 58]]];
  var T = {
    release: 1.15,      /* births spread over this long, from the gap */
    swirl: 0.75,        /* the flock begins to hold together */
    converge: 4.35,     /* the first birds turn for the mark */
    stagger: 1.05,      /* the last of them turn this much later */
    arrive: 1.85,       /* each bird's flight into the mark */
    fuse: 7.15,         /* the dust becomes the mark */
    text: 7.75,         /* the title comes in */
    shine: 7.55,        /* the band of light crosses the doves */
    shineFor: 1.05,
    end: 8.9
  };

  var state = null, timers = [], raf = 0;
  var cv, g, dpr = 1, vw = 0, vh = 0;
  var birds = [], order = [], mark = null, sil = null, path = null;
  var t0 = 0, last = 0, y0 = 0;
  var hero, slot;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(x) { x = clamp(x, 0, 1); return x * x * (3 - 2 * x); }
  function ease(x) { x = clamp(x, 0, 1); return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function gold(t, k) {
    t = clamp(t, 0, 1);
    for (var i = 1; i < GOLD.length; i++) {
      if (t <= GOLD[i][0]) {
        var a = GOLD[i - 1], b = GOLD[i], f = (t - a[0]) / (b[0] - a[0]);
        var c = [0, 1, 2].map(function (j) { return Math.round((a[1][j] + (b[1][j] - a[1][j]) * f) * (k || 1)); });
        return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
      }
    }
    return 'rgb(207,169,58)';
  }

  /* ---- where the doves of the mark are: their ink, sampled as screen points with the gold at each ---- */
  function sampleMark(n) {
    var doves = slot.querySelectorAll('.vr-mark__dove');
    if (!doves.length) return null;
    var box = slot.getBoundingClientRect();
    if (box.width < 20) return null;
    var W = Math.ceil(box.width), H = Math.ceil(box.height);
    var off = document.createElement('canvas'); off.width = W; off.height = H;
    var og = off.getContext('2d');
    var cand = [];
    /* the silhouette of the whole mark, in the mark's own box, for the band of light at the end */
    var silC = document.createElement('canvas'); silC.width = Math.round(W * dpr); silC.height = Math.round(H * dpr);
    var sg = silC.getContext('2d');
    Array.prototype.forEach.call(doves, function (dv) {
      var svgEl = dv.querySelector('svg.vr-mark__art');
      if (!svgEl) return;
      var vb = svgEl.viewBox && svgEl.viewBox.baseVal;
      var aw = vb && vb.width ? vb.width : 98, ah = vb && vb.height ? vb.height : 107;
      var r = dv.getBoundingClientRect();
      var k = Math.min(r.width / aw, r.height / ah);
      var ox = r.left - box.left + (r.width - aw * k) / 2, oy = r.top - box.top + (r.height - ah * k) / 2;
      var mirror = dv.classList.contains('vr-mark__dove--mirror');
      var shapes = Array.prototype.map.call(svgEl.querySelectorAll('.vr-mark__art path, path'), function (p) { return new Path2D(p.getAttribute('d')); });
      var draw = function (ctx, s) {
        ctx.save();
        ctx.scale(s, s);
        if (mirror) { ctx.translate(ox + aw * k, oy); ctx.scale(-k, k); } else { ctx.translate(ox, oy); ctx.scale(k, k); }
        shapes.forEach(function (p) { ctx.fill(p, 'evenodd'); });
        ctx.restore();
      };
      og.clearRect(0, 0, W, H);
      og.fillStyle = '#000';
      draw(og, 1);
      sg.fillStyle = '#fff';
      draw(sg, dpr);
      var d = og.getImageData(0, 0, W, H).data;
      for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
        if (d[(y * W + x) * 4 + 3] > 140) {
          /* the gold at this point: the mark's gradient runs across each dove (mirrored on the right) */
          var ax = (x - ox) / k, ay = (y - oy) / k;
          if (mirror) ax = aw - ax;
          var tt = ((ax) * aw + (ay - 38) * 28) / (aw * aw + 28 * 28);
          cand.push({ x: box.left + x + 0.5, y: box.top + y + 0.5, t: tt });
        }
      }
    });
    if (!cand.length) return null;
    /* an even scatter over the ink: shuffle and keep points not too close to one kept already */
    for (var i = cand.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var tmp = cand[i]; cand[i] = cand[j]; cand[j] = tmp; }
    var area = cand.length;
    var gap = Math.max(1.2, Math.sqrt(area / n) * 0.62);
    var kept = [], cell = {}, cs = gap;
    var key = function (x, y) { return Math.floor(x / cs) + ',' + Math.floor(y / cs); };
    for (i = 0; i < cand.length && kept.length < n; i++) {
      var c = cand[i], ok = true, gx = Math.floor(c.x / cs), gy = Math.floor(c.y / cs);
      for (var a = -1; a <= 1 && ok; a++) for (var b = -1; b <= 1 && ok; b++) {
        var list = cell[(gx + a) + ',' + (gy + b)];
        if (list) for (var q = 0; q < list.length; q++) { var e = list[q]; if ((e.x - c.x) * (e.x - c.x) + (e.y - c.y) * (e.y - c.y) < gap * gap) { ok = false; break; } }
      }
      if (!ok) continue;
      kept.push(c);
      var kk = key(c.x, c.y); (cell[kk] = cell[kk] || []).push(c);
    }
    while (kept.length < n) kept.push(cand[Math.floor(Math.random() * cand.length)]);
    return { pts: kept, box: { x: box.left, y: box.top, w: W, h: H }, sil: silC };
  }

  /* ---- the flock's path over the hall: a smooth curve through points, ending at the mark ---- */
  function makePath(m) {
    var land = vw >= vh;
    var mx = (m.box.x + m.box.w / 2) / vw, my = (m.box.y + m.box.h / 2) / vh;
    var pts = land
      ? [[0.5, 0.5], [0.3, 0.33], [0.55, 0.2], [0.77, 0.38], [0.66, 0.66], [0.38, 0.6], [mx, my]]
      : [[0.5, 0.5], [0.26, 0.34], [0.7, 0.22], [0.76, 0.52], [0.34, 0.68], [0.5, 0.48], [mx, my]];
    return pts.map(function (p) { return { x: p[0] * vw, y: p[1] * vh }; });
  }
  function along(P, u) {
    /* Catmull-Rom through P, u from 0 to 1 */
    var n = P.length - 1, f = clamp(u, 0, 1) * n, i = Math.min(n - 1, Math.floor(f)), t = f - i;
    var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(n, i + 2)];
    var t2 = t * t, t3 = t2 * t;
    return {
      x: 0.5 * (2 * p1.x + (-p0.x + p2.x) * t + (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 + (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3),
      y: 0.5 * (2 * p1.y + (-p0.y + p2.y) * t + (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 + (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3)
    };
  }

  /* ---- the birds ---- */
  function makeBirds(n) {
    var list = [];
    var small = Math.min(vw, vh) < 560;
    for (var i = 0; i < n; i++) {
      var side = i % 2 ? 1 : -1;
      var r = Math.sqrt(Math.random()), a = rnd(0, Math.PI * 2);
      list.push({
        born: Math.pow(Math.random(), 1.4) * T.release,
        x: vw / 2 + side * rnd(0, 4), y: vh * rnd(0.22, 0.78),
        vx: side * rnd(140, 520) * (small ? 0.7 : 1), vy: rnd(-140, 140), zNow: 0.4,
        z: rnd(0.55, 1.3), near: Math.random() < 0.12 ? rnd(1.9, 2.7) : 0,
        sx: r * Math.cos(a), sy: r * Math.sin(a),
        w1: rnd(0.6, 1.3), w2: rnd(0.5, 1.2), p1: rnd(0, 6.3), p2: rnd(0, 6.3),
        phase: rnd(0, 6.3), freq: rnd(6.2, 8.8),
        delay: Math.pow(Math.random(), 0.8) * T.stagger,
        tone: rnd(0.32, 0.86),
        th: Math.atan2(rnd(-0.4, 0.4), side),
        tx: 0, ty: 0, tg: 0.6, e: 0, done: false
      });
    }
    list.forEach(function (b) { if (b.near) { b.vx *= 1.5; b.vy *= 1.6; } });
    return list;
  }

  function size() {
    vw = window.innerWidth; vh = window.innerHeight;
    dpr = Math.min(window.devicePixelRatio || 1, 1.75);
    cv.width = Math.round(vw * dpr); cv.height = Math.round(vh * dpr);
    cv.style.width = vw + 'px'; cv.style.height = vh + 'px';
  }

  function drawBird(b, s, flap, fold, alpha, color) {
    var c = Math.cos(b.th), sn = Math.sin(b.th);
    g.setTransform(dpr * c, dpr * sn, -dpr * sn, dpr * c, dpr * b.x, dpr * b.y);
    var span = s * 0.5 * (1 - 0.7 * fold) * (0.7 + 0.3 * Math.abs(Math.cos(b.phase)));
    var lift = s * 0.34 * flap * (1 - fold);
    var tipU = -s * 0.1 + lift * 0.3, ctlU = s * 0.16 + lift;
    g.globalAlpha = alpha;
    g.strokeStyle = color; g.fillStyle = color;
    g.lineWidth = Math.max(0.9, s * 0.115);
    g.beginPath();
    g.moveTo(tipU, -span);
    g.quadraticCurveTo(ctlU, -span * 0.42, 0, 0);
    g.quadraticCurveTo(ctlU, span * 0.42, tipU, span);
    g.stroke();
    g.beginPath();
    g.ellipse(s * 0.04, 0, s * 0.19, s * 0.075, 0, 0, Math.PI * 2);
    g.fill();
  }

  function frame(now) {
    if (state !== 'flying') return;
    var t = (now - t0) / 1000;
    var dt = Math.min(0.05, (now - last) / 1000 || 0.016);
    last = now;
    if (window.innerWidth !== vw || window.innerHeight !== vh) { finish(true); return; }
    g.setTransform(1, 0, 0, 1, 0, 0);
    if (t < T.converge + 0.9) {
      g.globalCompositeOperation = 'destination-out';
      /* short streaks while the birds are fast (leaving the doors), longer once they flock */
      g.globalAlpha = 1; g.fillStyle = 'rgba(0,0,0,' + (0.52 + 0.4 * (1 - smooth((t - 1.2) / 1.1))).toFixed(3) + ')';
      g.fillRect(0, 0, cv.width, cv.height);
      g.globalCompositeOperation = 'source-over';
    } else {
      g.clearRect(0, 0, cv.width, cv.height);
    }

    /* the flock's body: its middle on the path, breathing, turned along its way */
    var su = smooth((t - T.swirl) / (T.converge + 0.6 - T.swirl));
    var mid = along(path, su * 0.999), ahead = along(path, Math.min(0.999, su + 0.03));
    var turn = Math.atan2(ahead.y - mid.y, ahead.x - mid.x);
    var land = vw >= vh;
    var stretch = Math.sin(t * 0.85);
    var rx = (land ? 0.27 * vw : 0.4 * vw) * (1 + 0.42 * stretch), ry = (land ? 0.17 * vh : 0.15 * vh) * (1 - 0.28 * stretch);
    var bend = 0.95 * Math.sin(t * 0.62 + 0.6);
    var shrink = 1 - 0.55 * smooth((t - T.converge + 0.4) / 1.6);
    rx *= shrink; ry *= shrink;
    var ct = Math.cos(turn), st = Math.sin(turn);
    /* the glare of the opening doors: birds are dark against it at first */
    var glare = 1 - smooth((t - 0.4) / 1.6);

    var fuseA = 1 - smooth((t - T.fuse) / 0.85);
    order.sort(function (p, q) { return birds[p].zNow - birds[q].zNow; });
    for (var oi = 0; oi < order.length; oi++) {
      var b = birds[order[oi]];
      var age = t - b.born;
      if (age < 0) continue;
      /* where it wants to be */
      var hold = smooth((t - T.swirl + 0.15 * b.z) / 0.9);
      /* a wave runs along the flock, and the flock bends: the further along a bird is, the more it is turned */
      var wave = Math.sin(b.sx * 4.4 - t * 2.7) * 0.24;
      var lx = b.sx * (1 + wave), ly = b.sy * (1 + wave * 0.6) + 0.18 * Math.sin(b.sx * 3.1 + t * 1.9);
      var ang = bend * lx, ca = Math.cos(ang), sa = Math.sin(ang);
      var ox = (lx * ca - ly * sa) * rx + 14 * Math.sin(t * b.w1 + b.p1), oy = (lx * sa + ly * ca) * ry + 10 * Math.cos(t * b.w2 + b.p2);
      var dx = mid.x + ox * ct - oy * st, dy = mid.y + ox * st + oy * ct;
      var cu = (t - T.converge - b.delay) / T.arrive;
      b.e = ease(cu);
      if (b.e > 0) { dx += (b.tx - dx) * b.e; dy += (b.ty - dy) * b.e; }
      /* spring and damping: loose in the flock, firm as it lands */
      var K = (5.5 + 34 * b.e * b.e) * hold, C = 2 * Math.sqrt(K + 0.0001) * (0.82 + 0.15 * b.e) + (1 - hold) * 0.9;
      if (b.e >= 1 && !b.done) { b.done = true; }
      if (b.done) { b.x += (b.tx - b.x) * Math.min(1, dt * 14); b.y += (b.ty - b.y) * Math.min(1, dt * 14); b.vx = 0; b.vy = 0; }
      else {
        var ax = K * (dx - b.x) - C * b.vx, ay = K * (dy - b.y) - C * b.vy;
        b.vx += ax * dt; b.vy += ay * dt;
        var sp = Math.sqrt(b.vx * b.vx + b.vy * b.vy), max = (land ? 760 : 560) * (1 - 0.5 * b.e);
        if (sp > max) { b.vx *= max / sp; b.vy *= max / sp; }
        b.x += b.vx * dt; b.y += b.vy * dt;
        if (sp > 8) { var want = Math.atan2(b.vy, b.vx), dth = Math.atan2(Math.sin(want - b.th), Math.cos(want - b.th)); b.th += dth * Math.min(1, dt * 9); }
      }
      b.phase += dt * 6.2832 * b.freq * (1 - 0.75 * b.e);
      var fold = smooth((b.e - 0.55) / 0.4);
      b.zNow = b.near ? b.near + (b.z - b.near) * smooth((age - 0.35) / 1.5) : b.z;
      var s = (b.zNow * (land ? 15 : 12)) * (0.35 + 0.65 * smooth(age / 0.7)) * (1 - 0.88 * fold) + 2.4 * fold;
      var born = smooth(age / 0.18);
      var col = b.e > 0.55 ? gold(b.tg) : gold(b.tone, 1 - 0.55 * glare * (1.2 - b.z * 0.4));
      var alpha = born * fuseA * (0.82 + 0.18 * Math.min(1, b.zNow));
      if (fold >= 0.98) {
        g.setTransform(dpr, 0, 0, dpr, 0, 0);
        g.globalAlpha = alpha; g.fillStyle = col;
        g.beginPath(); g.arc(b.x, b.y, 1.35, 0, Math.PI * 2); g.fill();
      } else {
        drawBird(b, s, Math.sin(b.phase), fold, alpha, col);
      }
    }
    g.globalAlpha = 1;

    /* the mark comes in beneath the dust */
    if (t >= T.fuse && !mark.shown) { mark.shown = true; if (window.VRBrandBirds) window.VRBrandBirds.still(); }
    if (t >= T.text && !mark.text) { mark.text = true; hero.classList.remove('is-awaiting-mark'); }
    /* one band of light across the doves */
    if (t >= T.shine && t <= T.shine + T.shineFor && mark.sil) {
      var p = smooth((t - T.shine) / T.shineFor);
      var bx = mark.box.x - mark.box.w * 0.4 + p * mark.box.w * 1.8;
      var lay = mark.layer;
      var lg = lay.getContext('2d');
      lg.setTransform(1, 0, 0, 1, 0, 0);
      lg.globalCompositeOperation = 'source-over';
      lg.clearRect(0, 0, lay.width, lay.height);
      var grd = lg.createLinearGradient((bx - mark.box.x - mark.box.w * 0.18) * dpr, 0, (bx - mark.box.x + mark.box.w * 0.18) * dpr, mark.box.h * dpr * 0.3);
      grd.addColorStop(0, 'rgba(255,250,232,0)'); grd.addColorStop(0.5, 'rgba(255,250,232,0.92)'); grd.addColorStop(1, 'rgba(255,250,232,0)');
      lg.fillStyle = grd; lg.fillRect(0, 0, lay.width, lay.height);
      lg.globalCompositeOperation = 'destination-in';
      lg.drawImage(mark.sil, 0, 0);
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalAlpha = Math.sin(Math.PI * p) * 0.9;
      g.drawImage(lay, mark.box.x * dpr, mark.box.y * dpr);
      g.globalAlpha = 1;
    }
    if (t >= T.end) { finish(false); return; }
    raf = window.requestAnimationFrame(frame);
  }

  function begin() {
    if (state !== 'waiting') return;
    cv = document.createElement('canvas');
    cv.className = 'vrs-flock';
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;left:0;top:0;z-index:10002;pointer-events:none;';
    document.body.appendChild(cv);
    g = cv.getContext('2d');
    if (!g) { finish(true); return; }
    size();
    var n = Math.round(Math.min(420, Math.max(170, vw * vh / 3300)));
    mark = sampleMark(n);
    if (!mark) { finish(true); return; }
    mark.layer = document.createElement('canvas');
    mark.layer.width = mark.sil.width; mark.layer.height = mark.sil.height;
    path = makePath(mark);
    birds = makeBirds(n);
    order = birds.map(function (b, i) { return i; });
    birds.forEach(function (b, i) { var p = mark.pts[i]; b.tx = p.x; b.ty = p.y; b.tg = p.t; });
    state = 'flying';
    t0 = last = performance.now();
    raf = window.requestAnimationFrame(frame);
  }

  function finish(fast) {
    if (state === 'done') return;
    var was = state;
    state = 'done';
    timers.forEach(function (id) { window.clearTimeout(id); });
    timers = [];
    if (raf) window.cancelAnimationFrame(raf);
    unlisten();
    if (window.VRBrandBirds) window.VRBrandBirds.still();
    if (hero) hero.classList.remove('is-awaiting-mark');
    if (cv && cv.parentNode) {
      var c = cv;
      if (fast || was !== 'flying') { c.parentNode.removeChild(c); }
      else { c.style.transition = 'opacity 0.4s ease'; c.style.opacity = '0'; window.setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 450); }
    }
  }

  /* anything the visitor does ends the show */
  function onMove() { finish(true); }
  function onScroll() { if (Math.abs((window.pageYOffset || 0) - y0) > 24) finish(true); }
  function onKey(e) { var k = e.key; if (k === ' ' || k === 'Enter' || k === 'Escape' || k === 'PageDown' || k === 'ArrowDown' || k === 'End' || k === 'Tab') finish(true); }
  function listen() {
    y0 = window.pageYOffset || 0;
    window.addEventListener('wheel', onMove, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('pointerdown', onMove, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('keydown', onKey);
  }
  function unlisten() {
    window.removeEventListener('wheel', onMove);
    window.removeEventListener('touchmove', onMove);
    window.removeEventListener('pointerdown', onMove);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('keydown', onKey);
  }

  /* delay: ms until the doors begin to open. Returns true if the show will run. */
  function play(delay) {
    if (state) return state === 'waiting' || state === 'flying';
    hero = document.querySelector('.vr-hero-section');
    slot = document.querySelector('[data-vr-brand-mark]');
    if (reduce || !hero || !slot || !window.requestAnimationFrame || !window.Path2D || !document.createElement('canvas').getContext) return false;
    state = 'waiting';
    hero.classList.add('is-awaiting-mark');
    listen();
    timers.push(window.setTimeout(begin, Math.max(0, delay || 0) + 120));
    /* whatever happens, the title is never held for long */
    timers.push(window.setTimeout(function () { finish(true); }, Math.max(0, delay || 0) + (T.end + 5) * 1000));
    return true;
  }

  window.VRStoryFlock = { play: play, skip: function () { finish(true); } };
})();
